import ExtraContentEditor from "./ExtraContentEditor";

export default ExtraContentEditor;
